<template>
  <div
    class="city-card"
    :class="{ 'city-card-selected': selected, 'city-card-disabled': disabled }"
    @click="!disabled && $emit('select', offer.id)"
  >
    <div class="city-name">{{ offer.cityName }}</div>
    <div class="city-details">
      <div class="city-detail-item">
        <iconify-icon icon="lucide:map-pin" style="margin-right: 6px;" />
        {{ offer.stateName }}
      </div>
      <div class="city-detail-item d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <iconify-icon icon="lucide:dollar-sign" style="margin-right: 6px;" />
          {{ offer.amountFormatted }}
        </div>
        <button
          v-if="offer.check_enrollment === 1 || offer.check_installments === 1 "
          class="btn-breakdown"
          :disabled="disabled"
          @click.stop="$emit('show-breakdown', offer)"
        >
          Detalles del monto
        </button>
      </div>
      <div class="city-detail-item" v-if="offer.quantityFormatted">
        <iconify-icon icon="lucide:users" style="margin-right: 6px;" />
        {{ offer.registeredCountFormatted }} inscritos / {{ offer.remainingSlotsFormatted }} cupos disponibles
      </div>

    </div>
  </div>
</template>

<script setup>
defineProps({
  offer: {
    type: Object,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['select', 'show-breakdown']);
</script>

<style scoped>
.city-card {
  background: linear-gradient(135deg, hsl(343, 48%, 29%) 60%, hsl(351, 35%, 47%) 100%);
  border-radius: 1.5rem;
  padding: 1.5rem;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.city-card:hover {
  border-color: hsla(44, 38%, 52%, 0.5);
}

.city-card-selected {
  border-color: hsl(44, 38%, 52%);
  background: linear-gradient(135deg, hsl(342, 42%, 35%) 60%, hsl(351, 35%, 53%) 100%);
}

.city-card-disabled {
  opacity: 1;
  cursor: not-allowed;
  filter: grayscale(30%);
}

.city-card-disabled:hover {
  border-color: transparent;
}

.city-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: hsl(0, 0%, 100%);
  text-align: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
}

.city-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.city-detail-item {
  background: hsla(0, 0%, 0%, 0.15);
  border-radius: 12px;
  padding: 8px 16px;
  color: hsl(0, 0%, 100%);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}

.btn-breakdown {
  font-size: 0.75rem;
  text-decoration: none;
  color: hsl(345, 100%, 88%); /* Hermoso rosa suave análogo al vinotinto */
  font-weight: 700;
  background: hsla(0, 0%, 100%, 0.08);
  border: 1px solid hsla(345, 100%, 88%, 0.25);
  padding: 4px 12px;
  border-radius: 100px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  outline: none;
}

.btn-breakdown:hover {
  color: hsl(0, 0%, 100%);
  background: hsla(345, 100%, 88%, 0.18);
  border-color: hsla(345, 100%, 88%, 0.7);
  box-shadow: 0 2px 8px hsla(0, 0%, 0%, 0.15);
  transform: translateY(-1.5px);
}
</style>
